if (!customElements.get('product-upsell-recommendations')) {
  customElements.define(
    'product-upsell-recommendations',
    class ProductUpsellRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) {
          this.hidden = true;
          return;
        }

        if (this.dataset.loaded === 'true') return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
      }

      async load() {
        this.abortController = new AbortController();
        try {
          const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`;
          const response = await fetch(url, { signal: this.abortController.signal });
          if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.querySelector(`product-upsell-recommendations[data-block-id="${this.dataset.blockId}"]`);
          const content = source?.querySelector('[data-product-upsell-content]');

          if (!content) {
            this.hidden = true;
            this.innerHTML = '';
            return;
          }

          this.innerHTML = content.outerHTML;
          this.dataset.loaded = 'true';
          this.removeAttribute('aria-busy');
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.hidden = true;
          this.innerHTML = '';
        }
      }
    }
  );
}
